import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useAccounts } from '../lib/useAccounts';
import { followUps } from '../lib/salesData';
import CalendarGrid from '../components/CalendarGrid';

const BUCKETS = ['Overdue', 'Today', 'This week', 'This month', 'Next quarter'];

export default function SalesCalendar() {
  const { demo } = useAuth();
  const { data, loading } = useAccounts(demo);
  const nav = useNavigate();
  const items = useMemo(() => followUps(data?.accounts ?? []), [data]);

  if (loading) return <div className="loading"><div className="spinner" /> Loading sales calendar…</div>;
  const byBucket = (b: string) => items.filter((i) => i.due === b);
  const dueToday = byBucket('Today').length + byBucket('Overdue').length;

  return (
    <>
      <div className="page-head">
        <div><div className="page-title">Sales Calendar</div><div className="page-sub">Quote deadlines, follow-ups, client calls, and approval windows.</div></div>
        <span className="live-flag">{dueToday} due now</span>
      </div>

      <div className="grid sidebar-layout">
        <div className="card">
          <div className="card-header"><div><h3>Week View</h3><p>Commitments across the team.</p></div></div>
          <div className="card-body"><CalendarGrid /></div>
        </div>
        <div className="card">
          <div className="card-header"><div><h3>Sales Agenda</h3><p>Deadlines &amp; follow-ups by window.</p></div></div>
          <div className="card-body">
            {BUCKETS.map((b) => {
              const g = byBucket(b);
              if (g.length === 0) return null;
              return (
                <div key={b} style={{ marginBottom: 12 }}>
                  <div className="section-h">{b} · {g.length}</div>
                  <div className="mini-list">
                    {g.slice(0, 8).map((it, i) => (
                      <div className="mini-row" key={i} onClick={() => nav(`/client?id=${encodeURIComponent(it.clientId)}`)} style={{ cursor: 'pointer' }}>
                        <div className="mr-main"><strong>{it.label}</strong><div className="mr-sub">{it.clientName}</div></div>
                        <span className={`tag ${it.kind === 'quote' ? 'pr-standard' : it.kind === 'lead' ? 'dp-sales' : 'pr-rush'}`}>{it.kind}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
            {items.length === 0 && <div className="empty">No sales events.</div>}
          </div>
        </div>
      </div>
    </>
  );
}
